import React from 'react';
import * as Icon from 'react-feather';
import {useAppDispatch} from '../../hooks/redux';

import {
    Button as AlchemyButton,
    Tooltip as AlchemyTooltip,
} from '@amzn/alchemy-components-react'

import { showEditBookmark, loadEditBookmark } from '../../slices/bookmarkModalSlice';
import i18n from '../../i18n';
import { Bookmark } from '../../types/Bookmark.type';

interface EditBookmarkButtonProps {
    bookmark: Bookmark;
    size?: "sm" | "md" | "lg";
    iconSize?: string;
}

export default function(props: EditBookmarkButtonProps) {
    const dispatch = useAppDispatch()
    const bookmark:Bookmark = props.bookmark
    const size = props.size || "sm"
    const iconSize = props.iconSize || "16"

    const handleEditBookmark = (bookmark: Bookmark) => {
        dispatch(showEditBookmark())
        dispatch(loadEditBookmark(bookmark))
    }

    return (
        <AlchemyTooltip position="top">
            <span slot="trigger">
                <AlchemyButton
                    size={size}
                    disabled={bookmark.disableRemove}
                    onClick={() => handleEditBookmark(bookmark)}
                >
                    <Icon.Edit3 size={iconSize} />
                </AlchemyButton>
            </span>
            <p className='mb-0'>{bookmark.disabledEdit ? i18n.t('button:unable-edit') : i18n.t('modal:edit-bookmark')}</p>
        </AlchemyTooltip>
    )
}
